import { useState, useEffect } from 'react';
import { MapPin } from 'lucide-react';

const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1920&q=80`;

const SLIDES = [
  {
    src: '/hero-borghetto.webp',
    place: 'Borghetto · Valeggio sul Mincio',
    credit: { text: 'Foto: Maurizio Moro, CC BY-SA 4.0', href: 'https://commons.wikimedia.org/wiki/File:Ponte_Visconteo_e_Canale_di_Borghetto.jpg' },
  },
  { src: u('photo-1555796861-b29396df890e'), place: 'Verona' },
  { src: u('photo-1558211014-835834f7a838'), place: 'Peschiera del Garda' },
];
const INTERVAL = 7000;

export const HeroSlideshow = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    SLIDES.forEach((s) => { new Image().src = s.src; });
  }, []);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const id = setTimeout(() => setIndex((i) => (i + 1) % SLIDES.length), INTERVAL);
    return () => clearTimeout(id);
  }, [index]);

  return (
    <div className="absolute inset-0" data-testid="hero-slideshow">
      {SLIDES.map((s, i) => (
        <img
          key={s.place}
          src={s.src}
          alt={s.place}
          loading={i === 0 ? 'eager' : 'lazy'}
          data-testid={`hero-slide-${i}`}
          className={`absolute inset-0 w-full h-full object-cover ease-out ${i === index ? 'opacity-100 scale-105' : 'opacity-0 scale-100'}`}
          style={{ transitionProperty: 'opacity, transform', transitionDuration: i === index ? '2000ms, 9000ms' : '2000ms, 0ms' }}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-[#121826]/95 via-[#1B275B]/85 to-[#121826]/60" />
      <div className="absolute bottom-8 left-4 sm:left-8 z-20 flex items-center gap-3" data-testid="hero-slide-caption">
        <span className="flex items-center gap-1.5 text-[11px] tracking-[0.2em] uppercase text-white/70">
          <MapPin className="w-3 h-3 text-[#C9A227]" />{SLIDES[index].place}
        </span>
        {SLIDES[index].credit && (
          <a href={SLIDES[index].credit.href} target="_blank" rel="noopener noreferrer" className="hidden sm:inline text-[10px] text-white/40 hover:text-white/70 transition-colors" data-testid="hero-slide-credit">
            {SLIDES[index].credit.text}
          </a>
        )}
        <div className="flex gap-1.5">
          {SLIDES.map((s, i) => (
            <button
              key={s.place}
              onClick={() => setIndex(i)}
              aria-label={s.place}
              data-testid={`hero-slide-dot-${i}`}
              className="h-6 px-0.5 flex items-center group"
            >
              <span className={`block h-[3px] rounded-full transition-[width,background-color] duration-500 ${i === index ? 'w-6 bg-[#C9A227]' : 'w-3 bg-white/40 group-hover:bg-white/70'}`} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
